import {SettingsProduction} from '../conf/settings.production';
import {Settings} from '../conf/settings.base';

export const environment = {
  production: true,
};

export const settings = new SettingsProduction() as Settings;
